
import NsHeaderTop from "./NsHeaderTop.vue";
import NsHeaderMid from "./NsHeaderMid.vue";
import { shopInfo, tree } from "@/api/shop/index";
import { mapGetters } from "vuex";
export default {
  props: {
    forceExpand: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShopHover: false,
      isIndex: false,
      thisRoute: "",
      goodsCategoryTree: [],
      selectedCategory: -1,
      navSelect: "",
      navList: [
        { nav_title: "店鋪首頁", id: "0" },
        { nav_title: "全部商品", id: "1" }
      ],
      site_id: "",
      shopInfo: {},
      loading: true
    };
  },
  components: {
    NsHeaderTop,
    NsHeaderMid
  },
  computed: {
    ...mapGetters(["defaultShopImage"])
  },
  beforeCreate() {},
  created() {
    if (!this.$route.query.site_id) {
      this.site_id = this.$route.path.replace("/shop-", "");
    } else {
      this.site_id = this.$route.query.site_id;
    }
    this.$store.dispatch("cart/cart_count");
    this.$store.dispatch("wholesaleCart/cart_count")
    this.getTree();
    if (this.$route.path == "/" || this.$route.path == "/index")
      this.isIndex = true;
    this.getShopInfo();
  },
  mounted() {},
  watch: {
    $route(curr) {
      if (!this.$route.query.site_id) {
        this.site_id = this.$route.path.replace("/shop-", "");
      } else {
        this.site_id = this.$route.query.site_id;
      }
      this.$store.dispatch("cart/cart_count");
      this.$store.dispatch("wholesaleCart/cart_count")
      this.getTree();
      if (this.$route.path == "/" || this.$route.path == "/index")
        this.isIndex = true;
      this.getShopInfo();
    }
  },
  methods: {
    getTree() {
      tree({ site_id: this.site_id })
        .then(res => {
          this.goodsCategoryTree = res.data;
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    //鼠標移入顯示商品分類
    shopHover() {
      if (this.goodsCategoryTree.length) {
        this.isShopHover = true;
      }
    },
    //鼠標移出商品分類隱藏
    shopLeave() {
      if (this.goodsCategoryTree.length) {
        this.isShopHover = false;
      }
    },
    navUrl(id) {
      if (id == 0) {
        this.$router.push("shop-" + this.site_id);
      } else if (id == 1) {
        this.$router.push({
          path: "shop_list",
          query: { site_id: this.site_id }
        });
      }
    },
    //獲取店鋪信息
    getShopInfo() {
      shopInfo({ site_id: this.site_id })
        .then(res => {
          if (res.code == 0) {
            this.shopInfo = res.data;
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err.message);
        });
    }
  }
};
